var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"52bb5627293db9bbea1d4d2b7c7a5830786afe9e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["roll-bits-vanda@reservamos"]={id:"52bb5627293db9bbea1d4d2b7c7a5830786afe9e"};
      